import {
  FormControl,
  FormErrorMessage,
  Input,
  Text,
} from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

import { ICreateApplicantRequest } from 'api/types/trueFileServerTypes';
import AsyncButton from 'components/form/AsyncButton';
import { truefilesColor } from 'themes/constants';

const ApplicantSchema = z.object({
  firstName: z.string().trim().min(1, { message: 'First Name is required' }),
  lastName: z.string().trim().min(1, { message: 'Last Name is required' }),
  middleName: z.string().trim().optional(),
  sin: z.number().min(100000000, { message: 'Valid SIN is required' })
    .max(999999999, { message: 'Valid SIN is required' }),
});

export function CreateApplicantForm(
  { onSubmit }: { onSubmit: (d: ICreateApplicantRequest)=> Promise<void> },
): JSX.Element {
  const methods = useForm<ICreateApplicantRequest>({
    resolver: zodResolver(ApplicantSchema),
  });

  const { register, handleSubmit, formState } = methods;
  const { errors } = formState;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: 600 }}>

        <FormControl isInvalid={!!errors.firstName} mb={4}>
          <Text
            fontSize='md' fontWeight='bold'
            mb='4px'
          >First name:
          </Text>
          <Input
            {...register('firstName')}
            placeholder='First name'
            border='2px solid'
            borderColor='gray.400'
            borderRadius='12px'
            focusBorderColor={truefilesColor}
            _placeholder={{ color: 'gray.400' }}
          />
          <FormErrorMessage>{errors.firstName?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.middleName} mb={4}>
          <Text
            fontSize='md' fontWeight='bold'
            mb='4px'
          >Middle name:
          </Text>
          <Input
            {...register('middleName')}
            placeholder='Middle name (optional)'
            border='2px solid'
            borderColor='gray.400'
            borderRadius='12px'
            focusBorderColor={truefilesColor}
            _placeholder={{ color: 'gray.400' }}
          />
          <FormErrorMessage>{errors.middleName?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.lastName} mb={4}>
          <Text
            fontSize='md' fontWeight='bold'
            mb='4px'
          >Last name:
          </Text>
          <Input
            {...register('lastName')}
            placeholder='Last name'
            border='2px solid'
            borderColor='gray.400'
            borderRadius='12px'
            focusBorderColor={truefilesColor}
            _placeholder={{ color: 'gray.400' }}
          />
          <FormErrorMessage>{errors.lastName?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.sin} mb={6}>
          <Text
            fontSize='md' fontWeight='bold'
            mb='4px'
          >SIN number:
          </Text>
          <Input
            {...register('sin', { valueAsNumber: true })}
            type='number'
            placeholder='SIN number'
            border='2px solid'
            borderColor='gray.400'
            borderRadius='12px'
            focusBorderColor={truefilesColor}
            _placeholder={{ color: 'gray.400' }}
          />
          <FormErrorMessage>{errors.sin?.message}</FormErrorMessage>
        </FormControl>

        <AsyncButton type='submit' formState={formState}>
          Add
        </AsyncButton>
      </form>
    </FormProvider>
  );
}
